import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('mixRateRow');

    return {
        AMOUNT_UNIT_LABELS: {
            FL_OZ: t('flOz'),
            G: t('g'),
            GAL: t('gal'),
            KG: t('kg'),
            L: t('l'),
            LB: t('lb'),
            ML: t('ml'),
            OZ_WT: t('ozWt'),
            PT: t('pt'),
            QT: t('qt')
        },
        AMOUNT_UNIT_PLACEHOLDER: t('amountUnitPlaceholder'),
        PER_UNIT_LABELS: {
            ACRE: t('acre'),
            GAL_WATER_100: t('galWater100'),
            GAL_WATER_1000: t('galWater1000'),
            HA: t('ha'),
            SQ_FT_1000: t('sqFt1000')
        },
        PER_UNIT_PLACEHOLDER: t('perUnitPlaceholder'),
        RATE_LABEL: t('rateLabel')
    };
};

export default useTranslation;
